import { useState } from 'react';
import { addDays, firstOfMonth, todayIn } from '@njpos/core';
import { api } from '../lib/api';
import { ErrorNote, useLoad } from '../components/ui';

const fmt = (iso: string) => new Date(`${iso}T12:00:00`).toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

// Closing the books: lock the past so a number you reported or filed cannot be changed by mistake.
export default function AcctClose() {
  const s = useLoad(() => api<any>('/api/accounting/books-settings'), []);
  const lastMonthEnd = addDays(firstOfMonth(todayIn()), -1);
  const [through, setThrough] = useState(lastMonthEnd);
  const [back, setBack] = useState('');
  const [err, setErr] = useState<unknown>(null);
  const [msg, setMsg] = useState('');
  const closed: string | null = s.data?.closedThrough ?? null;
  const act = async (fn: () => Promise<unknown>, done: string) => { setErr(null); setMsg(''); try { await fn(); setMsg(done); s.reload(); } catch (e) { setErr(e); } };
  return (
    <div className="stack">
      <ErrorNote error={err ?? s.error} />
      {msg && <div className="notice good">{msg}</div>}
      <div className="panel"><div className="panel-body stack">
        <h2 style={{ margin: 0 }}>{closed ? `Closed through ${fmt(closed)}` : 'Not closed'}</h2>
        <p className="muted">Close a month after you have balanced your bank accounts, paid the sales tax and given your numbers to your accountant. Nobody can then add, change or void anything dated on or before that day, so the reports for that period never change by accident. Sales that arrive late from a register are filed on the first open day instead.</p>
        <div className="field-row">
          <label>Close the books through<input type="date" value={through} max={addDays(todayIn(), -1)} onChange={(e) => setThrough(e.target.value)} /></label>
          <div style={{ alignSelf: 'end' }}><button className="primary" disabled={!through || (!!closed && through <= closed)} onClick={() => { if (confirm(`Close the books through ${fmt(through)}? Nothing dated on or before then can be added or changed.`)) act(() => api('/api/accounting/close', { body: { through } }), 'Closed.'); }}>Close the books</button></div>
        </div>
        {closed && (
          <div className="field-row">
            <label>Reopen back to (leave blank to reopen everything)<input type="date" value={back} max={addDays(closed, -1)} onChange={(e) => setBack(e.target.value)} /></label>
            <div style={{ alignSelf: 'end' }}><button onClick={() => { if (confirm(back ? `Reopen the books after ${fmt(back)}?` : 'Reopen all of the books? Past reports can change again.')) act(() => api('/api/accounting/reopen', { body: { through: back || null } }), 'Reopened.'); }}>Reopen</button></div>
          </div>)}
        <p className="faint">Closing and reopening are recorded in the audit log with who did it and when.</p>
      </div></div>
    </div>
  );
}
